import { render } from "./MyIncidents.vue?vue&type=template&id=22a5b76c&scoped=true"
import script from "./MyIncidents.vue?vue&type=script&lang=js"
export * from "./MyIncidents.vue?vue&type=script&lang=js"

import "./MyIncidents.vue?vue&type=style&index=0&id=22a5b76c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a5b76c"]])

export default __exports__